import { render } from "./startUpSteps.vue?vue&type=template&id=4a42221b&scoped=true"
import script from "./startUpSteps.vue?vue&type=script&lang=js"
export * from "./startUpSteps.vue?vue&type=script&lang=js"

import "./startUpSteps.vue?vue&type=style&index=0&id=4a42221b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a42221b"]])

export default __exports__